import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './home';
import {ChakraProvider} from '@chakra-ui/react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import AgendamentoPage from './pages/AgendamentoPage';
import DateFnsUtils from '@date-io/date-fns';
import {ptBR} from 'date-fns/locale';
import NotFoundPage from './pages/NotFoundPage';
import './img/favicon.ico'
// import DesenvolvimentoPage from './pages/WhithDevPage';
// import RedirectPage from './pages/RedirectPage';


const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
        <ChakraProvider>
            <BrowserRouter basename="/clinica-integrada">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path='*' element={<NotFoundPage/>} />
                    <Route path="/agendamento" element={<AgendamentoPage />} />
                    {/* <Route path='/' element={<DesenvolvimentoPage/>} /> */}
                    {/*<Route path="/escolha" element={<RedirectPage />} />*/}
                </Routes>
            </BrowserRouter>
        </ChakraProvider>
    </MuiPickersUtilsProvider>
);


